export enum UrgencyOptions {
    'Urgent - Affecting operations' = 'Urgent - Affecting operations',
    'High - Need ASAP' = 'High - Need ASAP',
    'Normal - Please fix soon' = 'Normal - Please fix soon',
    'Low - No timeframe' = 'Low - No timeframe'
}

export enum TypeOptions {
    'System accessibility' = 'System accessibility',
    'Error message' = 'Error message',
    'Bug/Tech problem' = 'Bug/Tech problem',
    'Question' = 'Question',
    'Suggestion' = 'Suggestion',
    'Service Request' = 'Service Request',
    'Other' = 'Other'
}

export class SupportRequest {
    subject: string = "";
    urgency?: UrgencyOptions = null;
    type?: TypeOptions = null;
    details: string = "";
    attachments: string[];
    _attachments: string = '';

    constructor(readonly user: string, readonly client: string, readonly role: string, public whereiwas: string, public referer: string) {}
}